import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
var Navigation = function Navigation(_ref) {
  var navigationItems = _ref.navigationItems;
  var activeTabRef = useRef(null);
  var location = useLocation();
  var user = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user;
  });
  useEffect(function () {
    var now = Date.now();
    if (activeTabRef.current) {
      var timeSpent = Math.round((now - activeTabRef.current.startTime) / 1000);
      var value = 'User Information';
      var path = activeTabRef.current.name.toLowerCase();
      if (path.includes('work')) {
        value = 'Work Information';
      } else if (path.includes('linked')) {
        value = 'Linked Accounts';
      } else if (path.includes('password')) {
        value = 'Change Password';
      } else if (path.endsWith('/account')) {
        value = 'User Information';
      }
      trackRubriqEvent("".concat(value, " Time Spent"), {
        time_spent_seconds: timeSpent,
        email: user === null || user === void 0 ? void 0 : user.email,
        user_identity: user.identity
      });
    }
    activeTabRef.current = {
      name: location.pathname,
      startTime: now
    };
  }, [location.pathname]);
  useEffect(function () {
    var handleLeave = function handleLeave() {
      if (activeTabRef.current) {
        var timeSpent = Math.round((Date.now() - activeTabRef.current.startTime) / 1000);
        trackRubriqEvent("".concat(activeTabRef.current.name, " Time Spent"), {
          time_spent_seconds: timeSpent,
          email: user === null || user === void 0 ? void 0 : user.email,
          user_identity: user.identity
        });
      }
    };
    window.addEventListener('pagehide', handleLeave);
    return function () {
      handleLeave();
      window.removeEventListener('pagehide', handleLeave);
    };
  }, []);
  var handleTabClick = function handleTabClick(navItem) {
    trackRubriqEvent('Profile Tab Clicked', {
      tab_name: navItem.name,
      tab_url: navItem.url,
      email: user === null || user === void 0 ? void 0 : user.email,
      user_identity: user.identity
    });
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-tabs nav-stacked flex-column"
  }, navigationItems.map(function (navItem) {
    return /*#__PURE__*/React.createElement("li", {
      className: "nav-item",
      key: navItem.url
    }, /*#__PURE__*/React.createElement(Link, {
      className: "nav-link ".concat(navItem.selected ? 'active' : ''),
      to: navItem.url,
      onClick: function onClick() {
        return handleTabClick(navItem);
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: navItem.name
    })));
  }));
};
export default Navigation;